import React, { type FC } from "react";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Image from "../../../../../../common-deprecated/styles/lexus/Image";
import type { SortedSpecType } from "../../../../../../common-deprecated/types/SpecTypes";
import { useBnbSelector } from "../../../redux/store";
import { useBnbOptionalLabel } from "../../../utils/labels";
import { getEcoImage } from "../../../utils/settings/bnbSettingUtils";
import { trackExpandSpecCategory } from "../../../utils/tracking";
import SpecList from "./SpecList";
import { useEcoConsumptionConfiguration } from "../../../hooks/summary/useEcoConsumptionConfiguration";
import { SummaryEcoConsumption } from "./SummaryEcoConsumption";

type EcoSpecsProps = {
    ecoSpecs: SortedSpecType[] | null;
    alternateFlow?: boolean;
};

export const SummaryEcoSpecs: FC<EcoSpecsProps> = (props): JSX.Element | null => {
    const { ecoSpecs, alternateFlow } = props;

    const bnbSettings = useBnbSelector((state) => state.bnbSettings);

    const [ecoDescription, ecoDisclaimer] = useBnbOptionalLabel(["ecoDescription", "ecoDisclaimer"]);
    // Remove alternate flow check when TDG is UPDATED with NEW VISUALS
    const ecoImage = !alternateFlow && getEcoImage(bnbSettings, ecoSpecs?.[0]);
    const ecoConsumptionConfiguration = useEcoConsumptionConfiguration();

    if (!ecoSpecs?.length) return null;
    return (
        <>
            {ecoConsumptionConfiguration && (
                <SummaryEcoConsumption ecoConsumptionConfiguration={ecoConsumptionConfiguration} />
            )}
            <SpecList
                specs={ecoSpecs}
                title={
                    <>
                        {ecoSpecs[0]?.title}{" "}
                        {ecoSpecs[0]?.disclaimer && <Popover showOnClick content={ecoSpecs[0].disclaimer} useHTML />}
                    </>
                }
                defaultOpen={alternateFlow}
                trackOpen={() => trackExpandSpecCategory("eco")}
            >
                {ecoImage && (
                    <Flex.Col mb={20} mt={2} px={0}>
                        {ecoDescription && <small>{ecoDescription}</small>}
                        <br />
                        <Image.Image src={ecoImage} alt="Ecolabel" />
                        <br />
                        {ecoDisclaimer && <small>{ecoDisclaimer}</small>}
                    </Flex.Col>
                )}
            </SpecList>
        </>
    );
};
